import { jsonApiVuex } from '@common/store/json-api-vuex';

export const integrationGoogleBigQuerySchemaTable = jsonApiVuex('integrations/google-big-query/schema-table', {}, {});